import { Flex, Skeleton } from 'antd'
import { BudgetCoinLoader } from 'src/pages/budget/components'

export const ArticleSkeleton = () => {
  const { Input } = Skeleton
  return (
    <Flex gap={24} vertical>
      <BudgetCoinLoader />
      <Input block active style={{ height: 80 }} />
      <Skeleton />
      <Input block active style={{ flex: 1, height: 400 }} />
    </Flex>
  )
}
